export async function sncBillingError(response?: Response): Promise<string> {
  const fallback = "SNC processing could not be completed. Review the invoice and payment status before retrying.";
  if (!response) return fallback;
  try {
    const body = await response.json();
    return typeof body?.message === "string" && body.message.trim()
      ? body.message
      : fallback;
  } catch (_) {
    return fallback;
  }
}
